import React from 'react';
import { pushFieldToDataLayer } from './guestwiseTracking';

const AreaPicker = ({ occasionBooking, selectedDay, selectedMonth, selectedYear, selectedHour, selectedMinute, numberOfGuests, areas, selectedArea, onChange }) => {

    if (!areas) return null;

    const getAreas = () => {
        if (areas) {
            let areaNameList = [];
            areas.forEach(area => {
                const areaName = area.areaLinkGroup?.areaLinks[0]?.name;
                const displayable = areaName &&
                    area.name.toLowerCase().indexOf('enquiry') == -1 &&
                    area.name.toLowerCase().indexOf('table') == -1;
                const matchesOccasion = !occasionBooking?.liveresId ||
                    (area.id || '').toLowerCase() === occasionBooking.liveresId.toLowerCase();
                if (displayable && matchesOccasion && !areaNameList.includes(areaName)) {
                    areaNameList.push(areaName);
                }
            });
            return areaNameList;
        }

        return [];

    }


    const handleAreaChange = (e) => {
        onChange(areas, e.target.value === "-" ? "" : e.target.value);
        pushFieldToDataLayer('booking_field_update', 'area', e.target.value);
    }

    return (
        <React.Fragment>
            <label className='label' htmlFor="booking-area">Preferred area of the restaurant</label>
            <div className="question-dropdown">
                <div className="question">
                    <select id="booking-area" data-guestwise="area" value={selectedArea?.areaLinkGroup?.areaLinks[0]?.name ?? "-"} className="select question-dropdown-select w-full" onChange={handleAreaChange}>
                        <option key="areaDefault">Select an area</option>
                        {getAreas().map((a, i) => (
                            <option key={i}>{a}</option>
                        ))}
                    </select>
                </div>
                <p className="field-info">
                    If you book a table outside and it rains on the day, we may not be able to move you inside if we're fully booked.
                </p>
            </div>
        </React.Fragment>
    );

}

export default AreaPicker;